export class Filter {
    name: string;
    value: string | number | string[] | number[] | boolean;
    operator: string;

    constructor(name: string, value: string | number | string[] | number[] | boolean, operator: string = '=') {
        this.name = name;
        if (typeof value === 'boolean') {
            this.value = +value;
        } else {
            this.value = value;
        }
        this.operator = operator;
    }
}



// WEBPACK FOOTER //
// /app/src/model/Helpers/Filter.ts